module.exports = __webpack_public_path__ + "d89aba23302b4e1b64bafa9deb9e12b9.png";


//////////////////
// WEBPACK FOOTER
// ./shared/components/Logo/assets/painters/efrdxv.png
// module id = 2438
// module chunks = 0